import clsx from 'clsx';
import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';

export default function Person({ blok }) {
  const styles = clsx('blok-person');

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <div>
        <img
          alt={blok.image.alt}
          className="h-52 w-52 rounded-full mb-4"
          src={blok.image.filename}
          width={400}
          height={400}
        />
      </div>
      {blok.name}
      <br />
      {blok.role}
    </div>
  );
}
